import type { ReactElement, SVGProps } from 'react'

/**
 * Swap-arrows glyph for SwapButton (36 × 37).
 *
 * Path data byte-identical to
 * `metro/docs/superpowers/specs/assets/routecard-v2/icon-swap.svg`
 * (Figma export). Four stroked paths, stroke 1.1636, round caps +
 * joins; bound to `currentColor` so the button tints via `text/secondary`.
 */
export function IconSwap(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path
        d="M20.2831 24.4678L23.0757 21.6751L20.2831 18.8825"
        stroke="currentColor"
        strokeWidth="1.1636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2154 21.6751H23.0757"
        stroke="currentColor"
        strokeWidth="1.1636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0083 11.1252L12.2157 13.9178L15.0083 16.7104"
        stroke="currentColor"
        strokeWidth="1.1636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0757 13.9178H12.2154"
        stroke="currentColor"
        strokeWidth="1.1636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
